import { settled } from 'common/types/Event-type.type';

export const EVENTS_TO_REFETCH_PRAISES = [
  settled('PraiseAdded'),
  settled('PraiseUpdated'),
  settled('PraiseDeleted'),
];
